const MuiTabsOverrides = {
  MuiTabs: {
    defaultProps: {
      variant: 'fullWidth'
    },
    styleOverrides: {
      root: {
        minHeight: 0
      },
      indicator: ({
        theme,
        ownerState
      }) => {
        return ownerState.disabled ? {
          backgroundColor: theme.palette.gray20
        } : {};
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        padding: theme.spacing(1),
        minHeight: 0,
        textTransform: 'none',
        borderBottom: `2px solid ${theme.palette.gray20}`,
        color: theme.palette.blue80,
        ...theme.typography.body02
      })
    }
  }
};

export { MuiTabsOverrides };
